<template>
  <div>
    <v-layout row wrap>
      <v-flex :class="{'lg2':graphicTypeFilter, 'lg4':!graphicTypeFilter}">
        <p class="headline mt-2">
          Gestiones
        </p>
      </v-flex>
      <graphic-types graphic-type="detailed" v-if="graphicTypeFilter"></graphic-types>
      <v-flex lg3 pl-3 mb-3>
        <v-menu
          ref="fromPicker"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="filters.from"
          transition="scale-transition"
          min-width="290px"
          lazy
          offset-y
          full-width>
          <v-text-field
            slot="activator"
            :value="formatDate(filters.from, 'YYYY-MM-DD', 'DD/MM/YYYY')"
            class="k-orange-linear-text"
            prepend-icon="event"
            readonly
            solo>
          </v-text-field>
          <v-date-picker
            v-model="filters.from"
            @input="$refs.fromPicker.save(filters.from)"
            locale="es"
            color="k-orange-linear">
          </v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex lg3 pl-3>
        <v-menu
          ref="toPicker"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="filters.to"
          transition="scale-transition"
          min-width="290px"
          lazy
          offset-y
          full-width>
          <v-text-field
            slot="activator"
            :value="formatDate(filters.to, 'YYYY-MM-DD', 'DD/MM/YYYY')"
            class="k-orange-linear-text"
            prepend-icon="event"
            readonly
            solo>
          </v-text-field>
          <v-date-picker
            v-model="filters.to"
            @input="$refs.toPicker.save(filters.to)"
            locale="es"
            color="k-orange-linear">
          </v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex lg2 pl-3 mb-3>
        <v-btn large block class="h-100 ma-0 white" @click="filter()">
          <v-icon>filter_list</v-icon>
          Filtrar
        </v-btn>
      </v-flex>
    </v-layout>
    <funnel-graphic
      graphic-id="detailedGraphic"
      url="notification_schedules/channel_metrics"
      :filters="filters"
      :labels="funnel[filters.channel].labels"
      :search-on-create="searchOnCreate">
    </funnel-graphic>
  </div>
</template>

<script>
import moment from 'moment';
import GraphicTypes from '@/components/panel/management/GraphicTypes';
import FunnelGraphic from '@/components/panel/management/FunnelGraphic';
import formatDateMixin from '@/mixins/formatDate';
import EventBus from '@/event-bus';

export default {
  props: {
    searchOnCreate: {
      type: Boolean,
      default: false,
    },
    graphicTypeFilter: {
      type: Boolean,
      default: true,
    },
    filterType: {
      type: String,
      default: '',
    },
  },
  components: {
    GraphicTypes,
    FunnelGraphic,
  },
  mixins: [
    formatDateMixin,
  ],
  created() {
    EventBus.$on('filterDetailedGraphic', (filters) => {
      Object.keys(filters).forEach((key) => {
        this.filters[key] = filters[key];
      });
      this.filters.fields = this.funnel[this.filters.channel].fields;
      this.filters.negative_statuses = this.funnel[this.filters.channel].negativeStatuses;
      setTimeout(() => {
        EventBus.$emit('detailedGraphicReload');
        EventBus.$emit('closeSidebar');
      });
    });
    EventBus.$on('showDetailedGraphic', () => {
      if (this.series.length) {
        EventBus.$emit('detailedGraphicRebuild');
      } else {
        EventBus.$emit('detailedGraphicReload');
      }
    });
    EventBus.$on('detailedGraphicSeries', (series) => {
      this.series = series;
    });
  },
  destroyed() {
    EventBus.$off('filterDetailedGraphic');
    EventBus.$off('showDetailedGraphic');
    EventBus.$on('detailedGraphicSeries');
  },
  data() {
    return {
      filters: {
        from: moment().startOf('month').format('YYYY-MM-DD'),
        to: moment().endOf('month').format('YYYY-MM-DD'),
        type: this.filterType,
        channel: 'email',
        fields: 'sent,read,click,payment_promise,payment_received',
        negative_statuses: 'Invalido,Marcado SPAM,Rebotado,Equivocado',
        tranche: '',
        portfolio_type: '',
      },
      funnel: {
        email: {
          fields: 'sent,read,click,payment_promise,payment_received',
          labels: [
            'Total',
            'Enviados',
            'Leidos',
            'Click',
            'Compromisos de pago',
            'Pagados',
          ],
          negativeStatuses: 'Invalido,Marcado SPAM,Rebotado,Equivocado',
        },
        sms: {
          fields: 'sent,delivered,click',
          labels: [
            'Total',
            'Enviados',
            'Entregados',
            'Click',
          ],
          negativeStatuses: 'Invalido,No enviado,No entregado',
        },
        ivr: {
          fields: 'sent,delivered,read,payment_promise,payment_received',
          labels: [
            'Total',
            'Enviados',
            'Entregados',
            'Escuchados',
            'Compromisos de pago',
            'Pagados',
          ],
          negativeStatuses: 'Invalido,Ocupado,Equivocado,Error,No contesta,No enviado,Buzon de voz,Rechazado',
        },
        bot: {
          fields: 'sent,delivered,read,payment_promise,payment_received',
          labels: [
            'Total',
            'Enviados',
            'Entregados',
            'Escuchados',
            'Compromisos de pago',
            'Pagados',
          ],
          negativeStatuses: 'Invalido,No contesta,Rechazado,Ocupado,Error,Equivocado',
        },
      },
      series: [],
    };
  },
  methods: {
    filter() {
      EventBus.$emit('openSidebar');
    },
  },
  watch: {
    'filters.from'() { // eslint-disable-line
      EventBus.$emit('detailedGraphicReload');
    },
    'filters.to'() { // eslint-disable-line
      EventBus.$emit('detailedGraphicReload');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/panel/management/Detailed.vue